<div class="settings-container">

  <!-- Header -->
  <div class="settings-header">
    <h2>Settings</h2>
  </div>

  <!-- Card -->
  <div class="settings-card">

    <!-- Delete Account -->
    <div class="setting-item delete" (click)="openDeleteDialog()">
      <div class="left">
        <span class="icon"><mat-icon>delete</mat-icon> </span>
        <span class="title">Delete Account</span>
      </div>
      <span class="arrow">›</span>
    </div>

  </div>

</div>